import Box from "@mui/material/Box";

// Progress bar of a budget: filled up to pct (capped at 100), optional tick at a threshold.
export default function BudgetBar({ pct, color, tick }: { pct: number | null; color: string; tick?: number }) {
  const width = Math.max(0, Math.min(100, pct ?? 0));
  return (
    <Box sx={{ position: "relative", height: 8, bgcolor: "#eef0f3", borderRadius: 1, my: 0.75 }}>
      <Box sx={{ width: `${width}%`, height: "100%", bgcolor: color, borderRadius: 1 }} />
      {tick !== undefined && tick < 100 && (
        <Box sx={{ position: "absolute", left: `${tick}%`, top: -2, width: "1px", height: 12, bgcolor: "#9ca3af" }} />
      )}
    </Box>
  );
}
